module.exports = {
	"app.name": "Depotwechsel",
	"api.path": "/api",
	"api.version": "v0",
	"assetsUrl": "https://s3.eu-central-1.amazonaws.com/fino-tenant-assets"
}


//////////////////
// WEBPACK FOOTER
// ./src/app/app.config.json
// module id = 1656
// module chunks = 0